import { render, staticRenderFns } from "./AppOverviewDeclarations.vue?vue&type=template&id=2b859a9c&"
import script from "./AppOverviewDeclarations.vue?vue&type=script&lang=ts&"
export * from "./AppOverviewDeclarations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports